import React from 'react';
import SvgWrapper from './SvgWrapper.js';

export default function Star(props) {
  return (
    <SvgWrapper angle={props.angle} scale={props.scale} left={props.left} top={props.top}>
      <svg width="80" height="70" viewBox="0 0 80 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M37.4019 4.5C38.5566 2.5 41.4434 2.5 42.5981 4.5L76.3731 63C77.5278 65 76.0844 67.5 73.775 67.5H6.22501C3.9156 67.5 2.47223 65 3.62693 63L37.4019 4.5Z" stroke={props.color || "#FBBC05"} stroke-width={props.thick || "5"} />
      </svg>
    </SvgWrapper>
  )
}
